export default "__VITE_ASSET__g26csNWF__"